import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../services/firebase";
import generateCustomID from "../../utils/generateCustomID";

const checkCustomerMembership = async (blockHouse) => {
  if (!blockHouse) return false;

  const customerId = generateCustomID(blockHouse.toUpperCase());
  const customerDocRef = doc(firestore, "customer", customerId);
  const customerDoc = await getDoc(customerDocRef);

  if (customerDoc.exists()) {
    const customerData = customerDoc.data();
    const membershipExpiry = customerData.membershipExpiry
      ? new Date(customerData.membershipExpiry)
      : null;
    const currentDate = new Date();

    if (membershipExpiry && membershipExpiry > currentDate) {
      return true;
    }
  }
  return false;
};

export default checkCustomerMembership;
